import { Link } from "react-router-dom";
import React from "react";

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col gap-2   p-6">
      <b>Il n'y a rien à voir içi!</b>
      <Link className="underline" to="/">Retourner à la page d'accueil</Link>
    </div>
  );
};

export default NotFound;
